// extracted by mini-css-extract-plugin
module.exports = {"courseAbout":"Introduction_courseAbout_3hd1b"};